import { Icons } from "assets/icons";
import { useSmartBack } from "hooks/useSmartBack";
import React, { useEffect, useRef } from "react";
import gsap from "utils/gsap";
import LanguageToggle from "components/layout/LanguageToggle";

const PageHeader = ({
  title,
  subtitle,
  isBackBtn = false,
  className = "",
  actions,
}) => {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const { arrowRight } = Icons;
  const goBack = useSmartBack();

  useEffect(() => {
    gsap.fromTo(
      titleRef.current,
      { opacity: 0, y: 8 },
      {
        opacity: 1,
        y: 0,
        duration: 0.35,
        ease: "power2.out",
      },
    );

    gsap.fromTo(
      subtitleRef.current,
      { opacity: 0, y: 6 },
      {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "power2.out",
        delay: 0.1,
      },
    );
  }, []);

  return (
    <div className={`page_header ${className}`}>
      <div className="page_header_wrapper">
        <div className="d-flex justify-content-between align-items-center gap-3">
          <div>
            <div className="d-flex align-content-center">
              {isBackBtn && (
                <img
                  src={arrowRight}
                  width={24}
                  height={24}
                  alt="icon"
                  className="back_arrow_icon"
                  onClick={goBack}
                />
              )}
              {title && (
                <h4
                  ref={titleRef}
                  className={`${isBackBtn ? "add_edit_form" : ""} page_title`}
                  style={{ opacity: 0 }}
                >
                  {title}
                </h4>
              )}
            </div>
            {subtitle && (
              <p
                ref={subtitleRef}
                className="page_sub_title"
                style={{ opacity: 0 }}
              >
                {subtitle}
              </p>
            )}
          </div>
          <div className="page_header_actions">
            {actions}
            <div className="page_header_language_toggle">
              <LanguageToggle />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
